import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { ProductTagsState } from '../types'

export const totalProductTagsSelector = createSelector<ReduxState, ProductTagsState, number>(
  featureStateSelector,
  state => state.pagination.total
)
